import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { LangProvider } from "@/context/LangContext";
import { StoreProvider } from "@/context/StoreContext";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { SmoothScroll } from "@/components/SmoothScroll";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import ContactPage from "@/pages/ContactPage";
import Home from "@/pages/Home";
import Checkout from "@/pages/Checkout";
import OrderPage from "@/pages/OrderPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import { AdminLogin, AdminShell } from "@/pages/admin/AdminShell";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminCities from "@/pages/admin/AdminCities";
import AdminSettings from "@/pages/admin/AdminSettings";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PublicLayout() {
  return (
    <>
      <SmoothScroll />
      <Header />
      <Outlet />
      <Footer />
      <CartDrawer />
      <WhatsAppFloat />
    </>
  );
}

export default function App() {
  return (
    <LangProvider>
      <StoreProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollTop />
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/order/:token" element={<OrderPage />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
              </Route>
              <Route path="/admin" element={<AuthProvider><Outlet /></AuthProvider>}>
                <Route path="login" element={<AdminLogin />} />
                <Route element={<AdminShell />}>
                  <Route index element={<AdminOverview />} />
                  <Route path="products" element={<AdminProducts />} />
                  <Route path="orders" element={<AdminOrders />} />
                  <Route path="delivery" element={<AdminCities />} />
                  <Route path="settings" element={<AdminSettings />} />
                </Route>
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" toastOptions={{ style: { background: "#0B0B0C", color: "#F7F3EB", border: "1px solid rgba(198,167,106,0.3)", borderRadius: 0 } }} />
        </CartProvider>
      </StoreProvider>
    </LangProvider>
  );
}
